import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import WmsLayout from '../layouts/WmsLayout';
import ConsolidationPage from './ConsolidationPage';
import ConsolidationPageOtherCarrier from './ConsolidationPageOtherCarrier';

const { TabPane } = Tabs;

const ConsolidationTabManager: React.FC = () => {
    const { t } = useTranslation();
    
    return (
            <Tabs 
                defaultActiveKey="swiftx" 
                type="card"
                className="h-full flex flex-col [&_.ant-tabs-content-holder]:flex-1 [&_.ant-tabs-content]:h-full [&_.ant-tabs-tabpane]:h-full"
            >
                <TabPane tab="SwiftX" key="swiftx">
                    <ConsolidationPage />
                </TabPane>
                <TabPane tab={t('wms.baggingTask.tabs.otherCarrier')} key="other-carrier">
                    <ConsolidationPageOtherCarrier />
                </TabPane>
            </Tabs>
    );
};

export default ConsolidationTabManager;
